import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '../../../utilities/helperUtility';
import * as _ from '../../../lodash';
import './index.css';

export default class TableComponent extends Component {
  parseTag(list, props) {
    let name = `${list.key}_${props.header}`;
    const { propsStyle = {} } = props;

    const style = {
      ...propsStyle.variantsTable,
      ...props.attrs[list.key].style,
    };

    switch (props.type) {
      case 'number':
        const { max = null } = props.attrs[list.key];
        const item = this.props.items[list.key];
        const { errorText } = this.props.style;
        const quantity = item ? item.quantity : 0;
        const { translation } = this.props;
        const unavailable = max < this.quantity(list);

        if (translation.key('columnQuantity') === props.header) name = `${list.key}_quantity`;

        return (
          <div style={{ position: 'relative' }}>
            <input
              max={this.variantMaxAvailability(item, max)}
              min={0}
              disabled={!max}
              name={name}
              type="number"
              style={{
                backgroundColor: this.props.style.body.backgroundColor,
                color: unavailable ? errorText.color : style.color,
              }}
              onInput={props.onChange.bind(this)}
              defaultValue={quantity}
            />
          </div>
        );
      case 'button':
        return (
          <button {...props.attrs[list.key]} name={name} style={style} onClick={props.onClick.bind(this)}>
            {props.content}
          </button>
        );
    }
  }

  variantMaxAvailability(item, max) {
    const { capacityType, items } = this.props;
    if (capacityType == 1 || !max) return max;
    const otherItems = Object.values(items).filter((i) => i !== item);
    return max - _.sumBy(otherItems, 'quantity');
  }

  errorMessage(list) {
    const column = this.props.extraColumns.find((col) => col.type === 'number');

    if (!column) return;

    const { max = null } = column.attrs[list.key];
    const { errorText } = this.props.style;
    if (max >= this.quantity(list)) return;

    return (
      <tr>
        <td colSpan={this.props.extraColumns.length + this.props.columns.headers.length}>
          <p style={{ color: errorText.color, float: 'right', margin: 0 }}>{this.props.limitedSpacesMessage || 'Sorry, limited spaces available'}</p>
        </td>
      </tr>
    );
  }

  quantity(list) {
    const { capacityType, items } = this.props;
    let item, quantity;

    if (capacityType === 1 ) {
      item = items[list.key];
      quantity = item ? item.quantity : 0;
    } else {
      item = Object.values(items)[0];
      quantity = item ? _.sumBy(Object.values(items), 'quantity') : 0;
    }
    const unitMultiplier = item ? item.unit_multiplier : 1;
    return quantity * unitMultiplier;
  }

  columnHead() {
    return this.props.columns.headers.map((header, i) => (
      <th style={{ minWidth: '45px', fontSize: this.fontSize() }} key={header + i}>
        <p>{capitalize(header)}</p>
      </th>
    ));
  }

  columnBody(list) {
    return this.props.columns.headers.map((header, i) => <td style={{fontSize: this.fontSize()}} key={list[header] + list.key + i}>{list[header]}</td>);
  }

  fontSize() {
    const { style } = this.props;
    if (!style) return 'inherit'
    const fontSize = style.body ? style.body.fontSize : '14px'
    return fontSize >= '14px' ? `calc(${fontSize || '16px'} - 2px)` : '12px';
  }

  extraColumnsHead() {
    return this.props.extraColumns.map((data) => (
      <th style={{fontSize: this.fontSize()}} key={data.header}>
        <p>{capitalize(data.header)}</p>
      </th>
    ));
  }

  extraColumnsBody(list) {
    return this.props.extraColumns.map((data, i) => (
      <th style={{fontSize: this.fontSize()}} key={data.header + list.key + i}>{this.parseTag(list, data)}</th>
    ));
  }

  render() {
    const {
      capacityType,
      columns: { lists },
      hideHead,
      className,
      columnReverse,
    } = this.props;

    return (
      <section className="fixed-thead" style={hideHead ? { paddingTop: '0' } : {}}>
        <div className="table-container">
          <table className={`pure-table pure-form center fluid ${className}`}>
            <thead style={hideHead ? { display: 'none' } : {}}>
              <tr>
                {columnReverse && this.extraColumnsHead()}
                {this.columnHead()}
                {!columnReverse && this.extraColumnsHead()}
              </tr>
            </thead>
            <tbody>
              {lists.map((list, i) => (
                <>
                <tr key={list.key + i}>
                  {columnReverse && this.extraColumnsBody(list)}
                  {this.columnBody(list)}
                  {!columnReverse && this.extraColumnsBody(list)}
                </tr>
                {capacityType === 1 && this.errorMessage(list)}
                </>
              ))}
              {lists.length && capacityType !== 1 && this.errorMessage(lists[0])}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}

TableComponent.propTypes = {
  columns: PropTypes.shape({
    headers: PropTypes.array.isRequired,
    lists: PropTypes.array.isRequired,
  }),
  extraColumns: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      type: PropTypes.string.isRequired,
      onChange: PropTypes.func,
    }),
  ),
};
